export default {
  records: [],
  total: 0,
  FilteredCount: 0,
  listLoading: false,
  saveLoading: false
}
